export default {
  areas: {
    hero: {
      eyebrow: 'Service area',
      title: 'Security cameras & alarm systems across the Rhine-Main region',
      subtitle: 'From Frankfurt via Offenbach, Hanau and Darmstadt to Groß-Gerau: SSG Signaltechnik plans, installs and maintains video surveillance and alarm systems for private and commercial customers – personally and on site.',
      ctaPrimary: 'Request a free initial consultation',
      ctaSecondary: 'Discover video surveillance',
    },
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Service area',
    intro: {
      eyebrow: 'Where we are active for you',
      title: 'Short distances across the whole region',
      p1: 'Our security technology specialist is based in Hainburg – and quickly on the move throughout the Rhine-Main region. Whether security camera, video surveillance or alarm system: we come to you, analyse your property on site and install everything cleanly and professionally.',
      p2: 'Whether private home, apartment building, retail space, office, warehouse or workshop – we handle projects of all sizes in Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau and all surrounding towns and communities.',
    },
    city: 'City',
    district: 'District',
    coverage: {
      eyebrow: 'Locally rooted',
      title: 'Your specialist from the region – for the region',
      p1: 'As a local security technology specialist in the Rhine-Main region, we know the requirements and conditions on site. For your security camera or alarm system this means: short travel distances, personal contacts and fast appointments – whether consulting, installation or maintenance.',
      p2: 'We are also on the move beyond the Rhine-Main region by arrangement. Just contact us – we will happily check what is possible for your project.',
      ctaPrimary: 'Enquire now',
      ctaSecondary: 'Discover alarm systems',
      caption: 'Personal installation and setup on site – from Hainburg across the Rhine-Main region.',
    },
    cta: {
      title: 'Security camera or alarm system for your property?',
      lead: 'We advise you without obligation and show you which solution fits your property and budget – across the Rhine-Main region and surroundings.',
      primary: 'Request a free initial consultation',
      secondary: 'Start the Camera Planner',
    },
  },
};